const services = [
  {
    icon: 'ri-home-2-line',
    title: 'Rénovation complète',
    description: 'Transformation totale de votre logement ou local commercial. Coordination de tous les corps de métier pour un résultat clé en main.',
    color: 'bg-emerald-500',
    textColor: 'text-emerald-400',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Cuisine',
    description: "Conception et installation de cuisines modernes et fonctionnelles. Agencement sur mesure, plan de travail, électroménager intégré.",
    color: 'bg-amber-500',
    textColor: 'text-amber-400',
  },
  {
    icon: 'ri-drop-line',
    title: 'Salle de bain',
    description: 'Rénovation complète de salles de bain. Carrelage, douche à l\'italienne, baignoire, meuble vasque, robinetterie haut de gamme.',
    color: 'bg-sky-500',
    textColor: 'text-sky-400',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Peinture & Revêtements',
    description: 'Peinture intérieure et extérieure, papier peint, enduits décoratifs. Finitions soignées pour un rendu professionnel.',
    color: 'bg-rose-500',
    textColor: 'text-rose-400',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Parquet & Carrelage',
    description: 'Pose de parquet massif, stratifié, carrelage et faïence. Large choix de matériaux pour tous les styles et budgets.',
    color: 'bg-orange-500',
    textColor: 'text-orange-400',
  },
  {
    icon: 'ri-door-open-line',
    title: 'Menuiserie',
    description: 'Portes intérieures, fenêtres, placards sur mesure, escaliers. Travaux de menuiserie bois et aluminium de qualité.',
    color: 'bg-teal-500',
    textColor: 'text-teal-400',
  },
  {
    icon: 'ri-building-line',
    title: 'Façade & Isolation',
    description: "Ravalement de façade, isolation thermique par l'extérieur (ITE), crépis, peinture façade. Amélioration énergétique garantie.",
    color: 'bg-violet-500',
    textColor: 'text-violet-400',
  },
  {
    icon: 'ri-tools-line',
    title: 'Travaux divers',
    description: 'Cloisons, faux plafonds, démolition, maçonnerie légère, aménagement de combles. Tous travaux de second œuvre.',
    color: 'bg-gray-500',
    textColor: 'text-gray-400',
  },
];

export default function RenovationServices() {
  return (
    <section className="py-24 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/30 rounded-full px-4 py-2 mb-5">
            <i className="ri-tools-line text-emerald-400 text-sm"></i>
            <span className="text-emerald-300 text-sm font-medium">Nos prestations</span>
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            Tous types de travaux<br />
            <span className="text-emerald-400">de rénovation</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed">
            De la rénovation complète aux petits travaux, CasaReNovaPlus prend en charge tous vos projets avec le même niveau d'exigence et de qualité.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div key={i} className="bg-white/5 border border-white/8 rounded-2xl p-6 hover:border-white/20 hover:-translate-y-1 transition-all duration-300">
              <div className={`w-12 h-12 flex items-center justify-center ${s.color}/20 rounded-xl mb-4`}>
                <i className={`${s.icon} ${s.textColor} text-xl`}></i>
              </div>
              <h3 className="text-white font-bold text-sm mb-2">{s.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
